<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible1"
        :close-on-click-modal="false"
        :modal="false"
        :title="customerFile.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="700px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="customerFile"
          :rules="ruleValidate"
          class="form"
          label-width="100px">
        <div class="vm-separate">
          <el-form-item label="文件名称" prop="fileName">
            <el-input v-model="customerFile.fileName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="打印机名称">
            <el-input v-model="customerFile.printerName" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="文件类型">
            <el-select v-model="customerFile.fileType" clearable placeholder="请选择">
              <el-option
                  v-for="item in fileType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="上传节点">
            <el-select v-model="customerFile.uploadNode" clearable placeholder="请选择">
              <el-option
                  v-for="item in upLoadNode"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="打印类型">
            <el-select v-model="customerFile.printType" clearable placeholder="请选择">
              <el-option
                  v-for="item in printType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="打印数量">
            <el-input v-model="customerFile.printQuantity" min="1" type="number" placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="关键字">
          <el-input v-model="customerFile.keyword" type="textarea"/>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible1=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "@/util/constant";
  export default {
    name:"CustomerDeliveryFileEdit",
    components: {},
    data() {
      return {
        constant,
        fileType: constant.toSelect(constant.fileType),
        upLoadNode: constant.toSelect(constant.upLoadNode),
        printType: constant.toSelect(constant.printType),
        dialogVisible1: false,
        contentLoading: false,
        submitLoading: false,
        customerFile: {
          pkid:"",
          masterId: "",
          fileName: "",
          printerName: "",
          fileType: 10,
          keyword: "",
          uploadNode: 10,
          printType: 10,
          printQuantity: 1,
          isDeleted: false,
        },
        ruleValidate: {
          fileName: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id,customerId) {
        this.customerFile.pkid = id;
        this.customerFile.masterId = customerId;
        this.dialogVisible1 = true;
        if(id>0) {
          this.getData();
        }
      },
      getData() {
        this.$http
          .get("basic", `customerDeliveryFiles/${this.customerFile.pkid}`)
          .then(resp => {
            console.log(resp);
            Object.assign(this.customerFile, resp);
            console.log(this.customerFile);
          });
      },
      handleSubmit() {
        if (this.customerFile.printQuantity <1) {
          return this.$message.error("打印数量最少为1份！！！");
        }
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .save("basic", "customerDeliveryFiles", this.customerFile)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible1 = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss">
  .col{
    .el-select{
      width: 60%;
    }
  }
  .col:last-child{
    .el-select{
      width: 72%;
      input{
        padding-right: 25px;
      }
    }
  }
</style>
